import { type AnalyticsPlatforms } from '../core/createAnalyticsProviders'
import { processEvent } from '../core/processEvent'
import { type PageViewEvent } from '../types/base/ga4-events'

export const sendPageViewEvent = (eventParams: PageViewEvent['eventParams'], platforms?: AnalyticsPlatforms[]) => {
  processEvent({
    event: {
      eventName: 'page_view',
      eventParams,
    },
    platforms,
  })
}
